import React from 'react'
import { Widget } from 'features/types'
import {
  TopicNotSelectedGuard,
  WidgetLoadingGuard,
  TopicInaccessibleGuard,
  TopicIndexNotReadyGuard
} from 'components/widget/share/guards'
import UnexpectedErrorBoundary from 'components/UnexpectedErrorBoundary'

import RunSearchEffect from '../share/RunSearchEffect'
import SummaryMetricsCompactNoDataGuard from '../share/guards/SummaryMetricsCompactNoDataGuard'
import SummaryMetricsCompactWidget from '../share/SummaryMetricsCompact'

const SocialWebSummaryMetricsCompactWidget: Widget = ({ widgetId }) => (
  <UnexpectedErrorBoundary>
    <TopicNotSelectedGuard widgetId={widgetId}>
      <RunSearchEffect widgetId={widgetId}>
        <WidgetLoadingGuard widgetId={widgetId}>
          <TopicInaccessibleGuard widgetId={widgetId}>
            <TopicIndexNotReadyGuard widgetId={widgetId}>
              <SummaryMetricsCompactNoDataGuard widgetId={widgetId}>
                <SummaryMetricsCompactWidget widgetId={widgetId} />
              </SummaryMetricsCompactNoDataGuard>
            </TopicIndexNotReadyGuard>
          </TopicInaccessibleGuard>
        </WidgetLoadingGuard>
      </RunSearchEffect>
    </TopicNotSelectedGuard>
  </UnexpectedErrorBoundary>
)

export default SocialWebSummaryMetricsCompactWidget
